import React from 'react';

const Terms = () => {
  return (
    <div style={{ padding: '3rem 1.5rem', maxWidth: '800px', margin: '0 auto', fontFamily: 'Inter, sans-serif', color: '#334155', lineHeight: '1.7' }}>
      <h1 style={{ color: '#0b2545', borderBottom: '1px solid #ddd', paddingBottom: '1rem' }}>Terms & Conditions</h1>
      <p style={{ fontSize: '0.9rem', color: '#64748b' }}>Last Updated: January 2026</p>

      <h3>1. Introduction</h3>
      <p>Welcome to <strong>www.abhikalpconsulting.com</strong>. This website is owned and operated by ARK Strategic Management Consultancy Services. By accessing this site, you agree to these terms. If you do not agree, please do not use the website.</p>

      <h3>2. Nature of Website</h3>
      <p>This website is an <strong>informational platform</strong> designed to showcase our strategic consultancy services. No legal services are delivered directly through the website interface, and no attorney-client relationship is formed merely by using this site.</p>

      <h3>3. Service Engagement</h3>
      <p>All engagements for consultancy, drafting, or advisory services are formalized through a separate engagement letter or email confirmation. The fees listed on this website are indicative and subject to the specific scope of work agreed upon.</p>

      <h3>4. Intellectual Property</h3>
      <p>All content on this site, including text, logos, and service descriptions, is the property of ARK Strategic Management Consultancy Services. You may not reproduce or redistribute this content without permission.</p>

      <h3>5. Limitation of Liability</h3>
      <p>The information provided on this website is for general guidance. ARK Strategic Management Consultancy Services is not liable for any actions taken based solely on the content of this website without professional consultation.</p>

      <h3>6. Governing Law</h3>
      <p>These terms are governed by the laws of India. Any disputes are subject to the exclusive jurisdiction of the courts in <strong>Mumbai, Maharashtra</strong>.</p>
    </div>
  );
};

export default Terms;